let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Uii1")).then(() => parcelRequire('aIk2W'));